import React from "react";
import { Stack } from "@mui/material";

import MobileSecondaryNavigationHeader from "@/components/header/navigation/mobile/_components/secondary-navigation/mobile-secondary-navigation-header";
import MobileSecondaryNavigationItemsExt from "@/components/header/navigation/mobile/_components/secondary-navigation/mobile-secondary-navigation-items-ext";
import MobileSecondaryNavigationItems from "@/components/header/navigation/mobile/_components/secondary-navigation/mobile-secondary-navigation-items";

import { NavigationType, PageTitle } from "@/components/header/common/header-enums";
import { HeaderNavProps } from "@/components/header/common/types";

type MobileSecondaryNavigationProps = {
  secondaryNavItems: HeaderNavProps[];
  currentPrimaryNavLabel: string;
  setActiveNavigation: (activeNavigation: NavigationType) => void;
  setTertiaryNavItems: (destination: HeaderNavProps[]) => void;
  setTertiaryHeaderLabel: (label: string) => void;
  setTertiaryHeaderLearnMoreUrl: (url: string) => void;
  setTertiaryHeaderViewAllDestinationsUrl: (url: string) => void;
};
export default function MobileSecondaryNavigation(props: MobileSecondaryNavigationProps) {
  const { secondaryNavItems, currentPrimaryNavLabel, setActiveNavigation, setTertiaryHeaderLabel,
    setTertiaryHeaderLearnMoreUrl, setTertiaryNavItems, setTertiaryHeaderViewAllDestinationsUrl } = props;

  return (
    <Stack>
      <MobileSecondaryNavigationHeader
        currentPrimaryNavLabel={currentPrimaryNavLabel}
        setActiveNavigation={setActiveNavigation}
      />
      {(() => {
        switch (currentPrimaryNavLabel) {
          case PageTitle.waysToTravel:
            return (
              <MobileSecondaryNavigationItemsExt
                secondaryNavItems={secondaryNavItems}
              />
            );
          default:
            return (
              <MobileSecondaryNavigationItems
                secondaryNavItems={secondaryNavItems}
                setActiveNavigation={setActiveNavigation}
                setTertiaryHeaderLabel={setTertiaryHeaderLabel}
                setTertiaryHeaderLearnMoreUrl={setTertiaryHeaderLearnMoreUrl}
                setTertiaryNavItems={setTertiaryNavItems}
                setTertiaryHeaderViewAllDestinationsUrl={setTertiaryHeaderViewAllDestinationsUrl}
              />
            );
        }
      })()}
    </Stack>
  );
}
